/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit BoardsWelcome/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function BoardsWelcome({
  children,
  viewPath = "/DesignSystem/Svgs/BoardsWelcome",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 196,
  height = 133,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#F2F2F2",
  fill3 = "#CCC",
  fill4 = "#fff",
  fill6 = "#FFB8B8",
  fill7 = "#6C63FF",
  fill9 = "#2F2E41",
  fill14 = "#3F3D56"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="BoardsWelcome.Svg"
  data-view-path={viewPath}
 viewBox="0 0 196 133"
 style={{'--as-1-1raMhK': alignSelf,'--mt-2-1raMhK': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1raMhK': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1raMhK': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1raMhK': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1raMhK': opacity,'--w-10-1raMhK': typeof width === 'number' ? `${width}px` : width,'--h-11-1raMhK': typeof height === 'number' ? `${height}px` : height,'--f-12-1raMhK': fill,'--a-7-1raMhK': isAnimated ? animation : "none",'--sd-8-1raMhK': isAnimated ? strokeDashoffset : 0,'--sd-9-1raMhK': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<g
  data-testid="BoardsWelcome.SvgGroup"
  data-view-path={viewPath}
 clipPath="url(#clip0_15214_1152)"
 className="views-block"
>
<path
  data-testid="BoardsWelcome.SvgPath"
  data-view-path={viewPath}
 d="M194.093 0H61.468a1.907 1.907 0 00-1.905 1.905v47.94h32.096a3.282 3.282 0 013.278 3.277V93.68h99.156a1.9 1.9 0 001.49-.72c.114-.14.206-.295.273-.461.096-.23.145-.475.144-.724V1.905A1.907 1.907 0 00194.093 0z"
 style={{'--f-12-1raMhK': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
<path
  data-testid="BoardsWelcome.SvgPath:1"
  data-view-path={viewPath}
 d="M195.726 7.637H59.834v.544h135.892v-.544zM64.464 5.72a1.634 1.634 0 100-3.269 1.634 1.634 0 000 3.268zM69.161 5.72a1.634 1.634 0 100-3.269 1.634 1.634 0 000 3.268zM73.859 5.72a1.634 1.634 0 100-3.269 1.634 1.634 0 000 3.268zM161.865 19.529h-68.17a2.84 2.84 0 000 5.68h68.17a2.843 2.843 0 002.84-2.84 2.842 2.842 0 00-2.84-2.84zm0 5.244h-68.17a2.404 2.404 0 010-4.807h68.17a2.406 2.406 0 012.403 2.403 2.405 2.405 0 01-2.403 2.404z"
 style={{'--f-12-1raMhK': fill3}}
 className={`views-block ${styles.SvgPath1}`}
/>
<path
  data-testid="BoardsWelcome.SvgPath:2"
  data-view-path={viewPath}
 d="M182.724 42.158h-68.169a2.839 2.839 0 00-2.84 2.84 2.839 2.839 0 002.84 2.84h68.169a2.84 2.84 0 100-5.68zM182.724 52.645h-68.169a2.839 2.839 0 00-2.008 4.85 2.839 2.839 0 002.008.831h68.169a2.841 2.841 0 100-5.68zM182.724 63.133h-68.169a2.839 2.839 0 00-2.84 2.84 2.839 2.839 0 002.84 2.841h68.169a2.841 2.841 0 100-5.68z"
 style={{'--f-12-1raMhK': fill4}}
 className={`views-block ${styles.SvgPath2}`}
/>
<path
  data-testid="BoardsWelcome.SvgPath:3"
  data-view-path={viewPath}
 d="M103.539 37.46h-31.03a2.514 2.514 0 00-2.511 2.51v9.874h.437v-9.873a2.077 2.077 0 012.073-2.074h31.031a2.074 2.074 0 012.073 2.074V71a2.072 2.072 0 01-2.073 2.074h-8.602v.436h8.602a2.51 2.51 0 002.51-2.51v-31.03a2.51 2.51 0 00-2.51-2.51z"
 style={{'--f-12-1raMhK': fill3}}
 className={`views-block ${styles.SvgPath3}`}
/>
<path
  data-testid="BoardsWelcome.SvgPath:4"
  data-view-path={viewPath}
 d="M23.078 69.386c-.11.004-4.787-.32-4.907-.324l.42-4.194 2.665-.08 5.09-9.43c-.706-1.346.163-3.133 1.661-3.408 3.018-.686 4.055 4.063 1.028 4.694l-4.211 11.522a1.868 1.868 0 01-1.746 1.22z"
 style={{'--f-12-1raMhK': fill6}}
 className={`views-block ${styles.SvgPath4}`}
/>
<path
  data-testid="BoardsWelcome.SvgPath:5"
  data-view-path={viewPath}
 d="M10.746 71.546c-4.45.011-4.841-6.716-.38-7.19 11.796-.712 10.303-3.675 11.199 5.064a.984.984 0 01-.873 1.082l-9.56 1.024c-.127.013-.256.02-.386.02z"
 style={{'--f-12-1raMhK': fill7}}
 className={`views-block ${styles.SvgPath5}`}
/>
<path
  data-testid="BoardsWelcome.SvgPath:6"
  data-view-path={viewPath}
 d="M9.73 50.278c6.133 3.49 1.099 12.696-5.148 9.418-6.131-3.49-1.097-12.696 5.149-9.418zM15.305 129.527h2.679l1.274-10.332h-3.953v10.332z"
 style={{'--f-12-1raMhK': fill6}}
 className={`views-block ${styles.SvgPath6}`}
/>
<path
  data-testid="BoardsWelcome.SvgPath:7"
  data-view-path={viewPath}
 d="M14.731 132.014h8.419c-.032-4.344-5.663-3.092-8.419-3.252v3.252z"
 style={{'--f-12-1raMhK': fill9}}
 className={`views-block ${styles.SvgPath7}`}
/>
<path
  data-testid="BoardsWelcome.SvgPath:8"
  data-view-path={viewPath}
 d="M3.725 129.527h2.679l1.274-10.332H3.725v10.332z"
 style={{'--f-12-1raMhK': fill6}}
 className={`views-block ${styles.SvgPath8}`}
/>
<path
  data-testid="BoardsWelcome.SvgPath:9"
  data-view-path={viewPath}
 d="M3.151 132.014h8.419c-.033-4.344-5.663-3.092-8.42-3.252l.001 3.252zM6.77 125.919c-.648-.178-4.166.359-4.581-.346-1.45-14.532-1.128-28.754 2.09-36.57l11.067-.677c2.475 4.518 8.163 34.495 4.732 36.317l-4.413.158a1.1 1.1 0 01-1.1-.836l-3.692-21.001c-.92-1.285-2.726 22.117-3.025 22.029a1.092 1.092 0 01-1.079.926z"
 style={{'--f-12-1raMhK': fill9}}
 className={`views-block ${styles.SvgPath9}`}
/>
<path
  data-testid="BoardsWelcome.SvgPath:10"
  data-view-path={viewPath}
 d="M3.928 90.84c-5.587-5.845-2.023-21.516-2.203-21.183.015-.384 1.28-6.296 4.554-7.266 2.597-.857 5.472 1.707 5.826 4.3l3.89 22.975a.81.81 0 01-.22.695c.19.596-11.573.36-11.847.48z"
 style={{'--f-12-1raMhK': fill7}}
 className={`views-block ${styles.SvgPath10}`}
/>
<path
  data-testid="BoardsWelcome.SvgPath:11"
  data-view-path={viewPath}
 d="M5.742 54.39c.49-.31.732-.842 1.018-1.327 1.504-.857 3.233 1.217 4.825.443 4.499-4.32-.126-5.594-4.27-5.822-.979-.12-1.811.227-2.552.8-8.277-.632-4.307 10.375.917 11.829.922.404 1.614-.414.8-1.157-1.125-1.18-2.519-3.555-.738-4.766z"
 style={{'--f-12-1raMhK': fill9}}
 className={`views-block ${styles.SvgPath11}`}
/>
<path
  data-testid="BoardsWelcome.SvgPath:12"
  data-view-path={viewPath}
 d="M91.66 49.407H31.792a3.72 3.72 0 00-3.715 3.715v75.598a3.719 3.719 0 003.715 3.714h59.866a3.719 3.719 0 003.715-3.714V53.122a3.72 3.72 0 00-3.715-3.715zm3.277 79.313a3.28 3.28 0 01-3.278 3.277H31.793a3.279 3.279 0 01-3.278-3.277V53.122a3.282 3.282 0 013.278-3.278h59.866a3.281 3.281 0 013.278 3.278v75.598z"
 style={{'--f-12-1raMhK': fill14}}
 className={`views-block ${styles.SvgPath12}`}
/>
<path
  data-testid="BoardsWelcome.SvgPath:13"
  data-view-path={viewPath}
 d="M14.925 81.22c-1.974.223-2.84-4.369-3.594-5.539l3.93-1.525 1.278 2.338 10.712.266c.064-.086.133-.168.208-.244 2.125-2.225 5.584 1.108 3.468 3.328a2.411 2.411 0 01-3.604-.104c-.265.018-12.14 1.486-12.398 1.48z"
 style={{'--f-12-1raMhK': fill6}}
 className={`views-block ${styles.SvgPath13}`}
/>
<path
  data-testid="BoardsWelcome.SvgPath:14"
  data-view-path={viewPath}
 d="M12.014 79.028c-.657.633-5.7-8.254-6.069-8.505-2.548-3.96 3.451-7.872 6.044-3.932l5.243 8.058a.984.984 0 01-.288 1.36c-.239.112-4.761 3.26-4.93 3.019z"
 style={{'--f-12-1raMhK': fill7}}
 className={`views-block ${styles.SvgPath14}`}
/>
<path
  data-testid="BoardsWelcome.SvgPath:15"
  data-view-path={viewPath}
 d="M79.86 101.736H43.592c-3.705-.018-3.72-5.661 0-5.68h36.27c3.702.017 3.722 5.661 0 5.68zM79.86 112.224H43.592c-3.705-.018-3.72-5.662 0-5.681h36.27c3.702.017 3.722 5.662 0 5.681zM79.86 122.712H43.592c-3.705-.018-3.72-5.662 0-5.681h36.27c3.702.017 3.722 5.661 0 5.681z"
 style={{'--f-12-1raMhK': fill3}}
 className={`views-block ${styles.SvgPath15}`}
/>
<path
  data-testid="BoardsWelcome.SvgPath:16"
  data-view-path={viewPath}
 d="M93.407 56.4a5.68 5.68 0 110-11.36 5.68 5.68 0 010 11.36z"
 style={{'--f-12-1raMhK': fill7}}
 className={`views-block ${styles.SvgPath16}`}
/>
<path
  data-testid="BoardsWelcome.SvgPath:17"
  data-view-path={viewPath}
 d="M96.03 50.5h-2.404v-2.731a.219.219 0 00-.437 0v2.73h-2.404a.218.218 0 100 .438h2.404v2.731a.219.219 0 00.437 0v-2.731h2.403a.219.219 0 000-.437z"
 style={{'--f-12-1raMhK': fill4}}
 className={`views-block ${styles.SvgPath17}`}
/>
<path
  data-testid="BoardsWelcome.SvgPath:18"
  data-view-path={viewPath}
 d="M79.205 89.239H44.246a3.609 3.609 0 01-3.605-3.606V66.057a3.609 3.609 0 013.605-3.605h34.96a3.61 3.61 0 013.604 3.605v19.576a3.61 3.61 0 01-3.605 3.606z"
 style={{'--f-12-1raMhK': fill7}}
 className={`views-block ${styles.SvgPath18}`}
/>
</g>
</svg>
{children}
</React.Fragment>)
}